<template>
  <!-- 公告栏看板 -->
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">水厂工艺流程图</span>
    </div>
    <div class="main-contanin">
      <div
        class="main-item"
        v-for="(item, index) in dataList"
        :key="item.bgUrl"
        @click="swichTab(item, index)"
      >
        <!-- <img
          v-if="index != 0"
          class="rightIcon"
          src="/pageIcons/icon-triangle@2x.png"
        /> -->
        <img
          class="mainImage"
          :src="item.bgUrl"
        />
        <span
          class="mainTitle"
          :style="{ color: index == selectIndex ? '#00ebee' : '#ffffff' }"
        >{{ item.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProcessFlowDIagram',
  components: {},
  data () {
    return {
      dataList: [
        {
          srcImgUrl: '/process.gif',
          bgUrl: '/pageIcons/icon-process-flow@2x.png',
          title: '工艺流程',
          index: 1
        },
        {
          srcImgUrl: '/iconImg/add-alum.gif',
          bgUrl: '/pageIcons/icon-add-vitriol-system@2x.png',
          title: '加矾系统',
          index: 2
        },
        {
          srcImgUrl: '/Preparation.gif',
          bgUrl: '/pageIcons/icon-sodium-hypochlorite@2x.png',
          title: '次氯酸钠制备间',
          index: 3
        },
        {
          srcImgUrl: '/bg-booster-pump.gif',
          bgUrl: '/pageIcons/icon-pump-station@2x.png',
          title: '加压泵站',
          index: 4
        },
        {
          srcImgUrl: '/iconImg/zhsc-pwxt.png',
          bgUrl: '/pageIcons/icon-sewer-system@2x.png',
          title: '排污系统',
          index: 5
        }
      ],
      selectIndex: 0
    }
  },
  created () { },
  methods: {
    swichTab (item, index) {
      this.selectIndex = index
      this.$emit('swichWater', item)
    }
  }
}
</script>

<style lang="less" scoped>
.mainWarp {
  height: 142px;
  width: 1308px;
  background: url(~@/assets/myImg/h_9_scgylct_box.png) no-repeat;
  background-size: contain;
  position: relative;
  .img-title {
    position: absolute;
    position: relative;
    top: -20px;
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;
    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
    img {
      width: 264px;
      height: 40px;
    }
  }
  .main-contanin {
    display: flex;
    justify-items: center;
    justify-content: center;
    .main-item {
      display: flex;
      justify-content: center;
      align-items: center;

      .rightIcon {
        height: 26px;
        width: 26px;
        margin: 26px;
      }
      .mainImage {
        height: 94px;
        width: 88px;
        cursor: pointer;
      }
      .mainTitle {
        font-family: MicrosoftYaHei-Bold;
        font-size: 20px;
        color: #23efff;
        font-weight: 700;
        cursor: pointer;
      }
    }
  }
}
</style>
